import React from "react";
import styled from "styled-components";
import Modal from "../../../components/advance/Modal";
import Button from "../../../components/core/EPL_Button_Think";

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 10px;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${"" /* background-color: pink; */}
  height: 100%;
  .circle {
    display: flex;
    background: #d4ae69;
    background: -moz-linear-gradient(
      309deg,
      rgba(212, 174, 105, 1) 0%,
      rgba(220, 195, 151, 1) 51%,
      rgba(255, 255, 255, 1) 100%
    );
    background: -webkit-linear-gradient(
      309deg,
      rgba(212, 174, 105, 1) 0%,
      rgba(220, 195, 151, 1) 51%,
      rgba(255, 255, 255, 1) 100%
    );
    background: linear-gradient(
      309deg,
      rgba(212, 174, 105, 1) 0%,
      rgba(220, 195, 151, 1) 51%,
      rgba(255, 255, 255, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#d4ae69",endColorstr="#ffffff",GradientType=1);
    border-radius: 50%;
    width: 10rem;
    height: 10rem;
    justify-content: center;
    align-items: center;
  }
  .icon {
    text-align: center;
    margin: 0 auto;
    font-size: 5rem;
    color: #c7222a;
  }
  .modalMessages {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    font-size: 18px;
  }
  .modalMessageHeading {
    margin-top: 30px;
    padding: 5px;
    color: #c7222a;
    font-size: 3rem;
  }
  .modalMessage {
  }
  .modalSubmitButton {
    background-color: #c7222a;
    color: white;
    font-size: 2rem;
    width: 15rem;
  }
`;

function ScenarioBasedModal({
	isOpen,
	showConfettiEffect = false,
	showCloseButton = true,
	closeButtonStyle = undefined,
	closeonClickOutside = true,
	onClose,
	id,
	className,
	modalImage = null,
	modalIcon,
	modalMessageHeading = null,
	boldMessage1="",
	boldMessage2="",
	modalMessage,
	modalMessage2,
	modalMessage3,
	modalMessage4,
	onModalSubmit,
	removeButton = false,
	modalSubmitMessage = "Okay",
	modalMessageHeadingStyle = undefined,
	modalMessageStyle = undefined,
	modalMessage2Style = undefined,
	modalMessage3Style = undefined,
	modalMessage4Style = undefined,
	modalSubmitMsgStyle = undefined,
	modalMsgs = undefined,
	style = undefined,
	modalStyle = undefined,
	additionalMesssage = "",
	confetti_className = undefined,
}) {
	// // console.log("gottta");
	// // console.log(isOpen, modalIcon, modalMessageHeading, modalMessage, modalImage, onClose, onModalSubmit);
	return (
		<Modal
			id={id}
			className={className}
			open={isOpen}
			isConfetti={showConfettiEffect}
			showCloseButton={showCloseButton}
			closeButtonStyle={closeButtonStyle}
			closeonClickOutside={closeonClickOutside}
			onClose={onClose}
			modalStyle={{ ...modalStyle }}
			style={{ ...style }}
		>
			<ModalWrapper className={confetti_className}>
				{modalImage && (
					<img
						src={modalImage}
						alt="Img"
						className="Img"
						loading="eager"
					/>
				)}
				{modalIcon && (
					<div className="circle">
						<div className="icon">{modalIcon}</div>
					</div>
				)}
				{modalMessageHeading && (
					<div
						className="modalMessageHeading"
						style={{ ...modalMessageHeadingStyle }}
					>
						{modalMessageHeading}
					</div>
				)}
				<div className="modalMessages"
					 style={{ ...modalMsgs}}
				>
					<div
						className="modalMessage"
						style={{ ...modalMessageStyle }}
					>
						<b>{boldMessage1}</b>{modalMessage}
					</div>
					<div
						className="modalMessage"
						style={{ ...modalMessage2Style }}
					>
						<b>{boldMessage2}</b>{modalMessage2}
					</div>
					<div
						className="modalMessage"
						style={{ ...modalMessage3Style }}
					>
						{modalMessage3}
					</div>
					<div
						className="modalMessage"
						style={{ ...modalMessage4Style }}
					>
						{modalMessage4}
					</div>
				</div>
				{removeButton ? (
					<></>
				) : (
					<Button
						id="modalSubmitButton"
						className="modalSubmitButton Btn ProceedBtn"
						disabled={false}
						onClick={onModalSubmit}
						style={{ ...modalSubmitMsgStyle }}
						text={modalSubmitMessage}
					/>
        )}
        {additionalMesssage !== "" ?
					<div className="modalMessage" style={style}>{additionalMesssage}</div>
				: <></>}

			</ModalWrapper>
		</Modal>
	);
}

export default ScenarioBasedModal;
